import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: "#272727",
        primary: "#272727",
        secondary: "#3c3f40",
        text: "#ffffff",
        accent: "#A68C59",
        error: "#b71c1c",
      },
    },
  },
});
